import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";
import jwt_decode from "jwt-decode";

// action types
export const VERIFY_AUTH = "verifyAuth";
export const LOGIN = "login";
export const LOGOUT = "logout";
export const REGISTER = "register";
export const UPDATE_USER = "updateUser";
export const CONFIRM = "confirm";
export const REPEAT_CODE = "repeatCode";
export const REPEAT_CODE_BY_PHONE = "repeatCodeByPhone";
export const RESET_PASSWORD = "resetPassword";
export const RESET_ERRORS = "resetErrors";

// mutation types
export const PURGE_AUTH = "logOut";
export const SET_AUTH = "setUser";
export const SET_ERROR = "setError";

const state = {
  errors: null,
  user: {},
  isAuthenticated: !!JwtService.getToken()
};

const getters = {
  currentUser(state) {
    return state.user;
  },
  isAuthenticated(state) {
    return state.isAuthenticated;
  },
  role() {
    if (JwtService.getToken()) {
      const decoded = jwt_decode(JwtService.getToken());

      return decoded.role;
    }
  }
};

const actions = {
  [LOGIN](context, credentials) {
    return ApiService.post("auth/sign_in", credentials)
      .then(({ data }) => {
        context.commit(SET_AUTH, data);

        return Promise.resolve(data);
      })
      .catch(({ response }) => {
        context.commit(SET_ERROR, response.data.errors.base);

        return Promise.reject(response);
      });
  },
  [LOGOUT](context) {
    context.commit(PURGE_AUTH);
  },
  [RESET_ERRORS](context) {
    context.commit(SET_ERROR, {});
  },
  [REGISTER](context, credentials) {
    return ApiService.api.auth.sign_up(credentials)
      .then(({ data }) => {
        context.commit(SET_AUTH, data);

        return Promise.resolve(data)
      })
      .catch(({ response }) => {
        context.commit(SET_ERROR, response.data.errors.base);

        return Promise.reject(response)
      });
  },
  [RESET_PASSWORD](context, credentials) {
    return ApiService.api.auth.resetPassword(credentials)
      .then(({ data }) => {
        return Promise.resolve(data)
      })
      .catch(({ response }) => {
        context.commit(SET_ERROR, response.data.errors.base);

        return Promise.reject(response)
      });
  },
  [CONFIRM](context, credentials) {
    return ApiService.api.auth.confirm(credentials)
      .then(({ data }) => {
        context.commit(SET_AUTH, data);

        return Promise.resolve(data)
      })
      .catch(({ response }) => {
        context.commit(SET_ERROR, response.data.errors.base);

        return Promise.reject(response)
      });
  },
  [REPEAT_CODE](context) {
    return ApiService.api.auth.repeatCode()
      .then(({ data }) => {
        return Promise.resolve(data);
      })
      .catch(({ response }) => {
        context.commit(SET_ERROR, response.data.errors.base);

        return Promise.reject(response)
      });
  },
  [REPEAT_CODE_BY_PHONE](context, data) {
    return ApiService.api.auth.repeatCodeByPhone(data)
      .then(({ data }) => {
        return Promise.resolve(data)
      })
      .catch(({ response }) => {
        context.commit(SET_ERROR, response.data.errors.base);

        return Promise.reject(response)
      });
  },
  [VERIFY_AUTH](context) {
    if (JwtService.getToken()) {
      ApiService.setHeader();

      return new Promise(resolve => {
        ApiService.get("auth/verify")
          .then(({ data }) => {
            context.commit(SET_AUTH, data);
            resolve(data);
          })
          .catch(({ response }) => {
            context.commit(SET_ERROR, response.data.errors);
            context.commit(PURGE_AUTH);
          });
      })
    } else {
      context.commit(PURGE_AUTH);
    }
  },
  [UPDATE_USER](context, payload) {
    const { email, username, password, image, bio } = payload;
    const user = { email, username, bio, image };
    if (password) {
      user.password = password;
    }

    return ApiService.put("user", user).then(({ data }) => {
      context.commit(SET_AUTH, data);
      return data;
    });
  }
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_AUTH](state, user) {
    state.isAuthenticated = true;
    state.user = user;
    state.errors = {};
    JwtService.saveToken(state.user.access_token);
  },
  [PURGE_AUTH](state) {
    state.isAuthenticated = false;
    state.user = {};
    state.errors = {};
    JwtService.destroyToken();
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
